import $axios from "../../api/axios";

function submitInfoApi({ params, callback }) {
  $axios
    .post(`/api/orders/customise`, params)
    .then(res => {
      callback(res);
    })
    .catch(err => {
      console.log(err);
    });
}

export default {
  submitInfoApi
};



// WEBPACK FOOTER //
// ./src/api/dtl/pia.js